import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice

const name = "E_Card";
const initialState = createInitialState();
const extraActions = createExtraActions();
const slice = createSlice({
    name,
    initialState,
    extraReducers: (builder) => {
        createExtraReducers(builder, extraActions);
    },
});

// exports

export const E_CardActions = { ...slice.actions, ...extraActions };
export const E_CardReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        LoadECardSearchDetails: [],
        InsertUpdateUspInmateInboxECardReadResponse: [],
        LoadECardResult: [],
        MyContactsDisplayForEcardDetails: [],
    };
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}`;


    return {
        getLoadE_CardList: getLoadE_CardList(),
        loadInsertUpdateUspInmateInboxECardRead: loadInsertUpdateUspInmateInboxECardRead(),
        loadECardDetails: loadECardDetails(),
        loadECardCategory: loadECardCategory(),
        LoadAllEcardForInmate: LoadAllEcardForInmate(),
        LoadSelectedEcardDetails: LoadSelectedEcardDetails(),
        LoadKeywordPUList: LoadKeywordPUList(),
        SaveInmateSendEcardDetails: SaveInmateSendEcardDetails(),
        InmateMyContactsDisplayForEcard: InmateMyContactsDisplayForEcard(),
        SendEcardNotificationEmail: SendEcardNotificationEmail()
    };

    function InmateMyContactsDisplayForEcard() {
        return createAsyncThunk(
            `${name}/InmateMyContactsDisplayForEcard`,
            async ({ InmateID, PublicUserID, ConnectionStatus, SortBy }) =>
                await fetchWrapper.get(`${baseUrl}/KioskECard/InmateMyContactsDisplayForEcard?InmateID=${InmateID}&PublicUserID=${PublicUserID}&ConnectionStatus=${ConnectionStatus}&SortBy=${SortBy}`)
        );
    }

    function SaveInmateSendEcardDetails() {
        return createAsyncThunk(
            `${name}/SaveInmateSendEcardDetails`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/KioskECard/SaveInmateSendEcardDetails`, objData)
        );
    }

    function SendEcardNotificationEmail() {
        return createAsyncThunk(
            `${name}/SendEcardNotificationEmail`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/KioskECard/SendEcardNotificationEmail`, objData)
        );
    }

    function LoadKeywordPUList() {
        return createAsyncThunk(
            `${name}/LoadKeywordPUList`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/KioskECard/LoadKeywordPUList`, objData)
        );
    }

    function LoadSelectedEcardDetails() {
        return createAsyncThunk(
            `${name}/LoadSelectedEcardDetails`,
            async ({ EcardId, FacilityId }) =>
                await fetchWrapper.get(`${baseUrl}/KioskECard/LoadSelectedEcardDetails?EcardId=${EcardId}&FacilityId=${FacilityId}`)
        );
    }

    function LoadAllEcardForInmate() {
        return createAsyncThunk(
            `${name}/LoadAllEcardForInmate`,
            async ({ CategoryId, PageNo, RowCountPerPage }) =>
                await fetchWrapper.get(`${baseUrl}/KioskECard/LoadAllEcardForInmate?CategoryId=${CategoryId}&PageNo=${PageNo}&RowCountPerPage=${RowCountPerPage}`)
        );
    }

    function loadECardCategory() {
        return createAsyncThunk(
            `${name}/loadECardCategory`,
            async () =>
                await fetchWrapper.get(`${baseUrl}/KioskECard/LoadEcardCategoryDropDown`)
        );
    }


    function getLoadE_CardList() {
        return createAsyncThunk(
            `${name}/getLoadE_CardList`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/KioskECard/LoadInmateInboxECard`, objData)
        );
    }

    function loadInsertUpdateUspInmateInboxECardRead() {
        return createAsyncThunk(
            `${name}/loadInsertUpdateUspInmateInboxECardRead`,
            async ({ eCardId, inmateId, PublicUserId }) =>
                await fetchWrapper.post(`${baseUrl}/KioskECard/LoadUpdateunreadEcardDetails?eCardId=${eCardId}&inmateId=${inmateId}&PublicUserId=${PublicUserId}`)
        );
    }
    function loadECardDetails() {
        return createAsyncThunk(
            `${name}/loadECardDetails`,
            async ({ eCardId }) =>
                await fetchWrapper.post(`${baseUrl}/KioskECard/LoadEcardDetails?eCardId=${eCardId}`)
        );
    }

}

function createExtraReducers(builder, actions) {
    builder
        .addCase(actions.getLoadE_CardList.pending, (state) => {
            state.LoadECardSearchDetails = [];
        })
        .addCase(actions.getLoadE_CardList.fulfilled, (state, action) => {
            state.LoadECardSearchDetails = action.payload;
        })
        .addCase(actions.getLoadE_CardList.rejected, (state, action) => {
            state.LoadECardSearchDetails = { error: action.error };
        })
        .addCase(actions.loadInsertUpdateUspInmateInboxECardRead.pending, (state) => {
            state.InsertUpdateUspInmateInboxECardReadResponse = [];
        })
        .addCase(actions.loadInsertUpdateUspInmateInboxECardRead.fulfilled, (state, action) => {
            state.InsertUpdateUspInmateInboxECardReadResponse = action.payload;
        })
        .addCase(actions.loadInsertUpdateUspInmateInboxECardRead.rejected, (state, action) => {
            state.InsertUpdateUspInmateInboxECardReadResponse = { error: action.error };
        })
        .addCase(actions.loadECardDetails.pending, (state) => {
            state.LoadECardResult = [];
        })
        .addCase(actions.loadECardDetails.fulfilled, (state, action) => {
            state.LoadECardResult = action.payload;
        })
        .addCase(actions.loadECardDetails.rejected, (state, action) => {
            state.LoadECardResult = { error: action.error };
        })
        .addCase(actions.InmateMyContactsDisplayForEcard.pending, (state) => {
            state.MyContactsDisplayForEcardDetails = [];
        })
        .addCase(actions.InmateMyContactsDisplayForEcard.fulfilled, (state, action) => {
            state.MyContactsDisplayForEcardDetails = action.payload;
        })
        .addCase(actions.InmateMyContactsDisplayForEcard.rejected, (state, action) => {
            state.MyContactsDisplayForEcardDetails = { error: action.error };
        });
}
